const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const MAX_EMAIL_LENGTH = 320;

export const isValidEmail = (email: string): boolean => {
  const trimmedEmail = email.trim();
  return (
    trimmedEmail.length > 0 &&
    trimmedEmail.length <= MAX_EMAIL_LENGTH &&
    EMAIL_REGEX.test(trimmedEmail)
  );
};
